module.exports = __webpack_public_path__ + "img/s3CardIcon6.b4d55e28.png";